export function assetUrl(path) {
  if (!path) return ''
  if (/^(https?:|data:|blob:)/.test(path)) return path
  const base = process.env.VUE_APP_BASE_API || ''
  return path.charAt(0) === '/' ? base + path : path
}
